export default __webpack_public_path__ + "static/media/wilde-masterImage2.3e871813.jpg";